import { useContext } from 'react';

import { MessagingContext, MessagingDeps } from './context';

/**
 * Reads the app-supplied messaging dependencies. Throws a clear error if a
 * messaging hook is used outside of <MessagingProvider> — this catches the
 * "provider mounted below the consumer" mistake at runtime instead of silently
 * no-oping.
 */
export function useMessagingDeps(): MessagingDeps {
  const deps = useContext(MessagingContext);
  if (!deps) {
    throw new Error(
      'useMessagingDeps must be used within a <MessagingDepsProvider>. Mount MessagingDepsProvider above any component that uses the messaging hooks.',
    );
  }
  return deps;
}
